import React from 'react';
import classNameBind from 'classnames/bind';
import { useTranslation } from '../Translator';
import Title from '../Title';
import Subtitle from '../Subtitle';
import Stack from '../Stack';
import styles from './SplashScreen.module.css';
import availableTypes from './types';

const bindClasses = classNameBind.bind(styles);
// TODO: Need to fix translations here

const SplashScreen = ({
  type,
  children,
  interpolations,
}) => {
  const { t } = useTranslation('components');

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="SplashScreen"
    >
      <Stack vertical spacing="extraWide" horizontalAlignment="middle">
        {
          type === 'custom'
            ? null
            : (
              <Stack.Item fill>
                <Title>{t(availableTypes[type].title, interpolations)}</Title>
                <Subtitle>{t(availableTypes[type].subtitle, interpolations)}</Subtitle>
              </Stack.Item>
            )
        }
        <div className={bindClasses('children')}>
          <Stack vertical horizontalAlignment="middle">
            {children}
          </Stack>
        </div>
      </Stack>
    </div>
  );
};

SplashScreen.defaultProps = {
  type: Object.keys(availableTypes)[0],
  children: null,
  interpolations: {},
};

SplashScreen.propEnums = {
  type: availableTypes,
};

export default SplashScreen;
